module.exports = __webpack_public_path__ + "img/img6.7384f6d8.svg";